<span class="segment-label"><ng-content></ng-content></span>
<ng-content select="cs-icon"></ng-content>
